import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface GetLeafsInput {
  application: string;
  itemId: string;
  rootId?: string;
  path?: string;
  params?: any;
  view?: string;
  query?: any;
  leafsClassId?: string;
  returnParentFields?: string[];
  returnFields?: string[];
  searchConfig?: any;
}

export interface GetLeafsOutput {
  length?: number;
  leafs?: any[];
}

export async function getLeafs(input: GetLeafsInput): Promise<FetchResponse<GetLeafsOutput>> {
  return await portalCustomAPI.fetch<GetLeafsInput, GetLeafsOutput>('getLeafs', input);
}
